import React, { useCallback, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setNewClientSeed } from 'redux-store/redux/slices/gameSettings.slice'
import { generateServerSeed } from 'redux-store/thunk/user.thunk'
import { generateClientSeed } from 'helpers/common.helpers'
import { openWarningToaster } from 'helpers/toaster.helpers'

export const ChangeSeedModal = () => {
  const { t } = useTranslation()
  const { clientSeed, serverSeedHash } = useSelector(state => state.gameSetting)
  const [editClientSeed, setEditClientSeed] = useState(false)
  const [inputClientSeed, setInputClientSeed] = useState(clientSeed)
  const inputRef = useRef()
  const dispatch = useDispatch()

  const handleGenerateServerSeed = e => {
    dispatch(generateServerSeed())
  }

  const handleGenerateClientSeed = useCallback(() => {
    const newSeed = generateClientSeed()
    dispatch(setNewClientSeed(newSeed))
  }, [])

  const handleChangeClientSeed = e => {
    if (editClientSeed) {
      setInputClientSeed(e.target.value)
    }
  }

  return (
    <div
      className='modal fade show'
      id='changeSeedModal'
      tabIndex='-1'
      role='dialog'
    >
      <div className='modal-dialog modal-dialog-centered modal-lg'>
        <div className='modal-content'>
          {/* <!-- MODAL BODY--> */}
          <div className='modal-body'>
            <div className='content-box p-lg-4'>
              <button
                type='button'
                className='btn-close btn-close-white float-end'
                data-bs-dismiss='modal'
                target='_blank'
              />
              <div className='row g-0'>
                <div className='col-md-12'>
                  <div className='side-content-box'>
                    <h1 className='modal-title text-center'>{t('changeSeedModal.heading')}</h1>
                    <div className='table-box'>
                      <div className='table-responsive'>
                        <p className='px-lg-5 text-center'>
                          {t('changeSeedModal.description')}
                        </p>
                      </div>
                      <div className='row'>
                        <div className='col-lg-7 order-1 order-lg-0'>
                          <div className='form-group mb-3'>
                            <label className='mb-1'>{t('changeSeedModal.clientSeed.label')}</label>
                            <input
                              type='text'
                              ref={inputRef}
                              contentEditable={editClientSeed}
                              value={editClientSeed ? inputClientSeed : clientSeed}
                              onChange={handleChangeClientSeed}
                              className='form-control change-seed-modal-seed-input'
                            />
                          </div>
                          <div className='form-group mb-3'>
                            <label className='mb-1'>{t('changeSeedModal.serverSeedHash.label')}</label>
                            <div className='form-control text-break change-seed-modal-seed-input'>
                              {serverSeedHash || t('changeSeedModal.loading')}
                            </div>
                          </div>
                        </div>
                        <div className='col-lg-5 mt-3 mb-3 mb-lg-0 order-0 order-lg-1'>
                          <button
                            className='btn btn-success w-100 mb-3'
                            onClick={e => {
                              setEditClientSeed(prev => !prev)
                              if (editClientSeed) {
                                if (inputClientSeed) {
                                  e.target.focus()
                                  dispatch(setNewClientSeed(inputClientSeed))
                                  setInputClientSeed('')
                                } else {
                                  openWarningToaster({ message: t('changeSeedModal.alphanumeric.message') })
                                }
                              } else {
                                inputRef.current.focus()
                              }
                            }}
                          >
                            {editClientSeed ? t('changeSeedModal.save.label') : t('changeSeedModal.editClientSeed.label')}
                          </button>
                          <button
                            className='btn btn-success w-100'
                            onClick={() => {
                              handleGenerateServerSeed()
                              handleGenerateClientSeed()
                            }}
                          >
                            Generate New Seeds
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
